(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('custom-collection-slider')) return;

    // 同ページ内の各インスタンスで読み込みを共有します。
    let splidePromise;
    function loadSplide() {
      if (window.Splide) return Promise.resolve(window.Splide);
      if (splidePromise) return splidePromise;

      splidePromise = new Promise((resolve, reject) => {
        let script = document.querySelector('script[src*="splide.min.js"]');
        const created = !script;
        if (created) {
          script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
          script.async = true;
        }
        const cleanup = () => {
          clearTimeout(timer);
          script.removeEventListener('load', loaded);
          script.removeEventListener('error', failed);
        };
        const loaded = () => {
          cleanup();
          if (window.Splide) resolve(window.Splide);
          else reject(new Error('Splide is unavailable.'));
        };
        const failed = () => {
          cleanup();
          if (created) script.remove();
          reject(new Error('Splide could not be loaded.'));
        };
        const timer = setTimeout(failed, 15000);
        script.addEventListener('load', loaded);
        script.addEventListener('error', failed);
        if (created) document.head.appendChild(script);
        else if (window.Splide) loaded();
      }).catch((error) => {
        splidePromise = null;
        throw error;
      });
      return splidePromise;
    }

    class CustomCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.generation = (this.generation || 0) + 1;
        const generation = this.generation;
        // テーマエディターで挿入された子要素の構築後に初期化します。
        this.frame = requestAnimationFrame(() => this.mount(generation));
      }

      async mount(generation) {
        const root = this.querySelector('.customCollection__splide');
        const list = root && root.querySelector('.splide__list');
        if (!list || !list.children.length || this.slider) return;

        try {
          const Splide = await loadSplide();
          if (!this.isConnected || generation !== this.generation) return;
          const multiple = list.children.length > 1;
          this.slider = new Splide(root, {
            type: multiple ? 'loop' : 'slide',
            focus: 'center',
            pagination: false,
            arrows: multiple,
            drag: multiple,
            autoWidth: true,
            perMove: 1,
            classes: {
              arrows: 'splide__arrows customCollection__arrows',
              arrow: 'splide__arrow customCollection__arrow',
              prev: 'splide__arrow--prev customCollection__arrow--prev',
              next: 'splide__arrow--next customCollection__arrow--next'
            }
          });

          // ループ用複製カードのIDと参照属性の重複を解消します。
          const fixClones = () => {
            root.querySelectorAll('.splide__slide--clone').forEach((clone, index) => {
              const ids = new Map();
              clone.querySelectorAll('[id]').forEach((element) => {
                const oldId = element.id;
                const newId = `${oldId}-cc-clone-${index}`;
                ids.set(oldId, newId);
                element.id = newId;
              });
              clone.querySelectorAll('[aria-labelledby], [aria-describedby], [for]').forEach((element) => {
                ['aria-labelledby', 'aria-describedby', 'for'].forEach((attribute) => {
                  if (!element.hasAttribute(attribute)) return;
                  element.setAttribute(attribute, element.getAttribute(attribute).split(/\s+/)
                    .map((id) => ids.get(id) || id).join(' '));
                });
              });
              clone.removeAttribute('data-shopify-editor-block');
            });
          };
          this.slider.on('mounted refresh', fixClones);
          this.slider.mount();

          this.onBlockSelect = (event) => {
            const originals = Array.from(list.children).filter((slide) => !slide.classList.contains('splide__slide--clone'));
            const index = originals.findIndex((slide) => slide.dataset.customCollectionBlock === event.detail.blockId);
            if (index !== -1) this.slider.go(index);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        } catch (error) {
          // CDN読み込み失敗時も商品へのリンクは表示します。
          root.style.visibility = 'visible';
          list.style.flexWrap = 'wrap';
          console.error('[custom-collection-slider]', error);
        }
      }

      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        cancelAnimationFrame(this.frame);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.slider) this.slider.destroy(true);
        this.slider = null;
      }
    }
    customElements.define('custom-collection-slider', CustomCollectionSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
